import { isEmpty, isString } from 'lodash';

const EMAIL_REGEX =
  /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

export const isValidEmail = (email = ''): boolean => {
  if (!isEmpty(email) && isString(email)) {
    return EMAIL_REGEX.test(email.toLowerCase());
  }

  return false;
};
